<template>
  <div
    class="collection-chip critical-component-hide"
    :class="[
      $blockClass(blockClass, 'collection-chip'),
      {
        [$class('loading')]: loading,
        [$class('active')]: isActive,
      },
    ]"
    @click="handleClick"
  >
    <div class="collection-chip__media">
      <responsive-image
        v-if="image"
        :class="$blockClass(blockClass, 'collection-chip-image')"
        :image="image"
        :lazy-load="false"
        :style="{ animationDelay: animationDelay }"
        block-class="collection-chip"
        min-max="80-240"
        ratio="1:1"
        sizes="80px"
      />
    </div>

    <div
      class="collection-chip__body"
    >
      <div
        v-if="collectionTitle"
        class="collection-chip__title"
        :class="$blockClass(blockClass, 'collection-chip-title')"
        :style="{ animationDelay: animationDelay }"
        v-text="collectionTitle"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product chip (product-chip)
 * -----------------------------------------------------------------------------
 * Displays contents of product chip.
 *
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {Boolean|Object} image - Image object.
 * @param {Number} index - Product chip's forloop index.
 * @param {Boolean} isActive - Product chip's active state.
 * @param {Boolean} loading - Product chip's loading state.
 * @param {String} collectionTitle - Collection title.
 */
import ResponsiveImage from '~global/images/responsive-image'

import { values as timings } from '~/config/timings'

export default {
  name: 'CollectionChip',

  components: {
    ResponsiveImage,
  },

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    image: {
      type: [Boolean, Object],
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Number,
      default: 0,
    },
    collectionTitle: {
      type: String,
      default: '',
    },
  },

  computed: {

    /**
     * Compute animation delay.
     * @returns {String}
     */
    animationDelay() {
      return `${this.index * timings.xs}s`
    },
  },
}
</script>

<style lang="scss">
@import './collection-chip';
</style>
